import { prop } from '@ipfabric/utils/fp/prop';
import { Dialog } from 'components/Dialog/Dialog';
import type { LeaveRouteHook } from 'containers/LeaveDialogue/useLeaveRoute';
import type { FC } from 'react';
import { useGraphContextSelectors } from '../GraphContext';
import { closeLeavingDialog } from '../commands/closeLeavingDialog';

interface Props {
  leaveRoute: LeaveRouteHook;
  onDiscardClick: () => void;
  onSaveClick: () => void;
  msg: {
    discard: string;
    save: string;
    header: string;
    subHeader: string;
  };
}

export const GraphPresetLeavingDialog: FC<Props> = (props) => {
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });

  const cancel = () => {
    ctxProps.dispatch(closeLeavingDialog);
    props.leaveRoute.cancel();
  };

  const handleDiscardClick = async () => {
    await props.onDiscardClick();
    props.leaveRoute.leave();
  };

  const handleSaveClick = async () => {
    await props.onSaveClick();
  };

  return (
    <Dialog
      headerMsg={props.msg.header}
      subHeaderMsg={props.msg.subHeader}
      primaryBtnMsg={props.msg.save}
      secondaryBtnMsg={props.msg.discard}
      onClose={cancel}
      onPrimaryClick={handleSaveClick}
      onSecondaryClick={handleDiscardClick}
      primaryBtnVariant='secondary'
      primaryBtnAccent='positive'
      secondaryBtnVariant='primary'
      secondaryBtnAccent='negative'
    />
  );
};
